<template>
  <v-dialog v-model="show" persistent :retain-focus="false" max-width="1140">
    <v-card>
      <v-card-title class="justify-center">
        <span class="text-h5"><strong> Edit Donor Information</strong></span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="createdDate"
                hide-details
                dense
                label="Date: dd-MM-yyyy"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field 
                v-model="item.donor_name" 
                label="Donor's Name*" 
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <p class="mb-0">Parent/Guardian*:</p>
              <v-radio-group row class="mt-0" v-model="item.s_w_d_of">
                <v-radio name="Parents_name" label="S" value="Son"></v-radio>
                <v-radio name="Parents_name" label="W" value="Wife"></v-radio>
                <v-radio name="Parents_name" label="D" value="Daughter"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="item.donor_parent_guardian_name"
                label="Parent/Guardian Name*"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field 
                v-model="item.age" 
                hide-details 
                label="Donor's Age*" 
                required
                 @paste.prevent
                @keypress="onlyAge"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <p class="mb-0">Sex*:</p>
              <v-radio-group row class="mt-0" v-model="item.sex">
                <v-radio name="sex" label="Male" value="Male"></v-radio>
                <v-radio name="sex" label="Female" value="Female"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-textarea
                v-model="item.postal_address"
                hide-details
                label="Postal Address*"
                required
                rows="2"
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field 
                v-model="item.phone_no" 
                label="Phone No*" 
                required
                counter="10"
                 @paste.prevent
                @keypress="onlyNumber"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                hide-details
                v-model="item.donor_relative_name"
                label="Received from (Name of nearest relation)*"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <p class="mb-0">Relative relation with Donor*:</p>
              <v-radio-group row class="mt-0" v-model="item.relation_with_donor" readonly>
                <v-radio name="donor_relation" label="Son" value="Son"></v-radio>
                <v-radio name="donor_relation" label="Wife" value="Wife"></v-radio>
                <v-radio name="donor_relation" label="Daughter" value="Daughter"></v-radio>
                <v-radio name="donor_relation" label="Others" value="Others"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" sm="6" md="4" v-if="item.relation_with_donor == 'Others'">
              <v-text-field 
                hide-details 
                v-model="item.donorOtherRelationshipName" 
                label="Relationship Name*" 
                required
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field 
                hide-details 
                v-model="item.referral_name" 
                label="Referral Name*" 
                required
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                hide-details
                label="Referral Contact No.*"
                required
                v-model="item.referral_contact_number"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <p class="mb-0">Requesting Person*:</p>
              <v-radio-group row class="mt-0" readonly v-model="item.category_type_of_the_requesting_person">
                <v-radio name="Parents_name" label="Eye Bank Staff" value="Eye Bank Staff"></v-radio>
                <v-radio name="Parents_name" label="Hospital Staff" value="Hospital Staff"></v-radio>
                <v-radio class="mt-2" name="Parents_name" label="Volunteer" value="Volunteer"></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-datetime-picker
                v-model="deathDate"
                date-format="dd-MM-yyyy"
                time-format="HH:mm"
                label="Date and Time of Death*"
              ></v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-datetime-picker
                v-model="consentDate"
                date-format="dd-MM-yyyy"
                time-format="HH:mm"
                label="Date and Time of Consent*"
              ></v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="6" md="4" v-if="item.formCFill == null">
              <v-datetime-picker
                v-model="excisionDate"
                date-format="dd-MM-yyyy"
                time-format="HH:mm"
                label="Date and Time of Excision*"
              ></v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="6" md="4" v-if="item.formCFill != null">
              <v-text-field 
                v-model="excisionDate" 
                label="Date and Time of Excision*" 
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field 
                v-model="item.cause_of_death" 
                label="Cause of Death*" 
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field 
                v-model="item.temperature" 
                label="Temperature*" 
                required
                @keypress="onlyNumber"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="item.consignment_information"
                label="Consignment Information*"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="receivedDate"
                label="Received on*"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
               <p class="body-1 mb-0 "><strong> INFORMATION ABOUT EYES RECEIVED</strong></p>
            </v-col>
            <v-col cols="12" md="5">
              <v-checkbox  class="mt-0" v-model="item.left_eye" label="L.E (OS)" value="LE" @click="restLE()"></v-checkbox>
              <v-textarea
                v-if="item.left_eye == 'LE'"
                v-model="item.condition_of_left_eye_ball_cornea_at_time_of_receive"
                label="Condition of Left Eye Ball/Cornea at time of receipt"
                rows="3"
                row-height="15"
              ></v-textarea>
              <v-textarea
                v-if="item.left_eye == 'LE'"
                v-model="item.condition_of_left_eye_ball_cornea_at_time_of_inspection"
                label="Condition of Left Eye Ball/Cornea on Inspection"
                rows="3"
                row-height="15"
              ></v-textarea>
            </v-col>
             <v-col cols="12" md="1"></v-col>
              <v-col cols="12" md="5">
              <v-checkbox class="mt-0" v-model="item.right_eye" label="R.E (OD)" value="RE" @click="restRE()"></v-checkbox>
              <v-textarea
                v-if="item.right_eye == 'RE'"
                v-model="item.condition_of_right_eye_ball_cornea_at_time_of_receive"
                label="Condition of Right Eye Ball/Cornea at time of receipt"
                rows="3"
                row-height="15"
              ></v-textarea>
              <v-textarea
                v-if="item.right_eye == 'RE'"
                v-model="item.condition_of_right_eye_ball_cornea_at_time_of_inspection"
                label="Condition of Right Eye Ball/Cornea on Inspection"
                rows="3"
                row-height="15"
              ></v-textarea>
            </v-col>
            <!-- <v-col cols="12" md="1"></v-col> -->
            <v-col cols="12" md="12">
              <v-textarea
                v-if="item.right_eye == 'RE' || item.left_eye == 'LE'"
                v-model="item.any_other_information"
                label="Any other Information"
                rows="2"
                row-height="15"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="5">
              <v-row>
                <v-col cols="12">
                  <p class="mb-0">Excision set</p>
                </v-col>
                <v-col cols="12">
                  <v-datetime-picker
                    v-model="excisionSterilizationDate"
                    date-format="dd-MM-yyyy"
                    time-format="HH:mm"
                    label="Excision set date and time of sterilization*"
                  ></v-datetime-picker>
                </v-col>
                <v-col cols="12">
                  <v-datetime-picker
                    v-model="excisionExpiryDate"
                     date-format="dd-MM-yyyy"
                    time-format="HH:mm"
                    label="Excision set date and time of expiry*"
                  ></v-datetime-picker>
                </v-col>
                <v-col cols="7">
                  <v-file-input
                    v-model="ExcisionSetInitals"
                    chips
                    accept="image/*"
                    label="Excision set initals*"
                    @change="onFileChangeExcision($event)"
                  />
                </v-col>
                <v-col v-if="!ExcisionSetInitalsObj&&item.excision_set_initials" cols="5">
                  <img  v-img style="width:100%" :src="!ExcisionSetInitalsObj?$assetUrl(item.excision_set_initials):''" />
                </v-col>

                 <v-col v-if="!!ExcisionSetInitalsObj"  cols="5">
                 <img v-img style="width: 100%;" :src="ExcisionSetInitalsObj?ExcisionSetInitalsObj:''" />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="5">
              <v-row>
                <v-col cols="12">
                  <p class="mb-0">Linen set</p>
                </v-col>
                <v-col cols="12">
                  <v-datetime-picker
                    v-model="linenSterilizationDate"
                     date-format="dd-MM-yyyy"
                    time-format="HH:mm"
                    label="Linen set date and time of sterilization*"
                  ></v-datetime-picker>
                </v-col>
                <v-col cols="12">
                  <v-datetime-picker
                    v-model="linenExpiryDate"
                     date-format="dd-MM-yyyy"
                    time-format="HH:mm"
                    label="Linen set date and time of expiry*"
                  ></v-datetime-picker>
                </v-col>
                <v-col cols="7" >
                  <v-file-input
                    v-model="LinenSetInitials"
                    chips
                    accept="image/*"
                    label="Linen set initials*"
                    @change="onFileChangeLinen"
                  />
                </v-col>
                 <v-col v-if="!LinenSetInitialsObj && item.linen_set_initials" cols="5">
                  <img  v-img style="width:100%" :src="!LinenSetInitialsObj?$assetUrl(item.linen_set_initials):''" />
                </v-col>

                 <v-col v-if="!!LinenSetInitialsObj"  cols="5">
                 <img v-img  style="width: 100%;" :src="LinenSetInitialsObj?LinenSetInitialsObj:''" />
                </v-col>
                
              </v-row>
            </v-col>
            <v-col cols="12" md="1"></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <v-file-input
                v-model="file"
                chips
                accept="image/*"
                label="Permission Certificate*"
                @change="onFileChange"
              />
            </v-col>
            <v-col v-if="!fileObj&&item.permission_certificate" cols="2">
                  <img  v-img style="width:105%" :src="!fileObj?$assetUrl(item.permission_certificate):''" />
                </v-col>

                 <v-col v-if="!!fileObj"  cols="2">
                 <img v-img style="width: 105%;" :src="fileObj?fileObj:''" />
                </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="samedata()"> Cancel </v-btn>
        <v-btn color="primary" @click="editDonorinformation()" :disabled="!formIsValid"> Update </v-btn>
      </v-card-actions>
      <v-snackbar v-model="snackbar" :timeout="timeout">
        {{ snackbarText }}

        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
        </template>
      </v-snackbar>
    </v-card>
  </v-dialog>
</template>
<script>
import { baseUrl, apiUrl, assetUrl } from '@/config/config'

import donorService from '@/service/Donor.service'
import moment from 'moment'
const localData = (JSON.parse(localStorage.getItem('token')) === null) ? window.location.href = '/' : JSON.parse(localStorage.getItem('token'));
// const token = localData.token

// const userName = localData.user_name
// const userNumber = localData.user_number
const userId = localData.user_id
const roleId = localData.Role_id

export default {
  data() {
    return{
      fileObj:'',
      LinenSetInitialsObj:'',
      ExcisionSetInitalsObj:'',
      snackbar: false,
      snackbarText: '',
      timeout: 10000,
      file:null,
      ExcisionSetInitals: null,
      LinenSetInitials: null
    }
  },

  props: ['visible', 'item','method'],

  computed: {
    formIsValid () {
      return (
        this.item.donor_name &&
        this.item.s_w_d_of &&
        this.item.donor_parent_guardian_name &&
        this.item.age &&
        this.item.sex &&
        this.item.postal_address &&
        this.item.phone_no &&
        this.item.donor_relative_name &&
        this.item.relation_with_donor &&
        this.item.referral_name &&
        this.item.referral_contact_number &&
        this.item.category_type_of_the_requesting_person &&
        this.item.date_of_time_of_death &&
        this.item.date_of_time_of_consent &&
        this.item.date_of_time_of_excision &&
        this.item.cause_of_death &&
        this.item.temperature &&
        this.item.received_on &&
        this.item.excision_set_date_and_time_of_sterilization &&
        this.item.excision_set_date_and_time_of_expiry &&
        this.item.linen_set_date_and_time_of_sterilization &&
        this.item.linen_set_date_and_time_of_expiry &&
        this.item.excision_set_initials &&
        this.item.linen_set_initials &&
        this.item.permission_certificate
      )
    },

    show: {
      get() {
          if(!this.item.donor_id && roleId !== 1){
          this.snackbar = true;
          this.snackbarText = 'The form is ideally filled by Counsellor Cum Technician.'
        }
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      },
    },

    
    // url() {
    //   if (!this.LinenSetInitials) return '';
    //   return URL.createObjectURL(this.LinenSetInitials);
    // },

    // url1() {
    //   if (!this.ExcisionSetInitals) return '';
    //   return URL.createObjectURL(this.ExcisionSetInitals);
    // },
    // url2() {
    //   if (!this.file) return '';
    //   return URL.createObjectURL(this.file)
    // },
    

    
    createdDate: {
      get() {
        return this.item.date ? moment.utc(this.item.date).format('DD-MM-YYYY HH:mm '):''
      },
    },

    deathDate: {
      get() {
        return this.item.date_of_time_of_death ? moment.utc(this.item.date_of_time_of_death).format('DD-MM-YYYY HH:mm') : ''
      },
      set(value) {
        this.$set(this.item, 'date_of_time_of_death', moment(value).format('YYYY-MM-DD HH:mm'))
      },
    },

    consentDate: {
      get() {
        return this.item.date_of_time_of_consent ? moment.utc(this.item.date_of_time_of_consent).format('DD-MM-YYYY HH:mm') : ''
      },
      set(value) {
        this.$set(this.item, 'date_of_time_of_consent', moment(value).format('YYYY-MM-DD HH:mm'))
      },
    },

    excisionDate: {
      get() {
        return this.item.date_of_time_of_excision ? moment.utc(this.item.date_of_time_of_excision).format('DD-MM-YYYY HH:mm') : ''
      },
      set(value) {
        this.$set(this.item, 'date_of_time_of_excision', moment(value).format('YYYY-MM-DD HH:mm'))
      },
    },

    receivedDate: {
      get() {
        return this.item.received_on ? moment.utc(this.item.received_on).format('DD-MM-YYYY HH:mm') : ''
      },
      set(value) {
        this.$set(this.item, 'received_on', moment(value).format('YYYY-MM-DD HH:mm'))
      },
    },

    excisionSterilizationDate: {
      get() {
        return this.item.excision_set_date_and_time_of_sterilization ? moment.utc(this.item.excision_set_date_and_time_of_sterilization).format('DD-MM-YYYY HH:mm') : ''
      },
      set(value) {
        this.$set(this.item, 'excision_set_date_and_time_of_sterilization', moment(value).format('YYYY-MM-DD HH:mm'))
      },
    },

    excisionExpiryDate: {
      get() {
        return this.item.excision_set_date_and_time_of_expiry ? moment.utc(this.item.excision_set_date_and_time_of_expiry).format('DD-MM-YYYY HH:mm'):''
      },
      set(value) {
        this.$set(this.item, 'excision_set_date_and_time_of_expiry', moment(value).format('YYYY-MM-DD HH:mm'))
      },
    },

    linenSterilizationDate: {
      get() {
        return this.item.linen_set_date_and_time_of_sterilization?moment.utc(this.item.linen_set_date_and_time_of_sterilization).format('DD-MM-YYYY HH:mm'):''
      },
      set(value) {
        this.$set(this.item, 'linen_set_date_and_time_of_sterilization', moment(value).format('YYYY-MM-DD HH:mm'))
      },
    },

    linenExpiryDate: {
      get() {
        return this.item.linen_set_date_and_time_of_expiry?moment.utc(this.item.linen_set_date_and_time_of_expiry).format('DD-MM-YYYY HH:mm'):''
      },
      set(value) {
        this.$set(this.item, 'linen_set_date_and_time_of_expiry', moment(value).format('YYYY-MM-DD HH:mm'))
      },
    },

  },

  methods: {

    // relationWithDonor(){
    //   if(this.item.relation_with_donor != "Others"){
    //     this.item.donorOtherRelationshipName = ""
    //   }
    // },

    samedata(){
      this.show = false
      this.method()
    },
    // same(item){
    //   this.editDonorinformation()
    // },

    restLE(){
      if(this.DonorInformationList.left_eye != 'LE'){
        this.item.condition_of_left_eye_ball_cornea_at_time_of_receive='',
        this.item.condition_of_left_eye_ball_cornea_at_time_of_inspection=''
      }
    },
    restRE(){
      if(this.DonorInformationList.right_eye != 'RE'){
        this.item.condition_of_right_eye_ball_cornea_at_time_of_receive='',
        this.item.condition_of_right_eye_ball_cornea_at_time_of_inspection=''
      }
    },

    onFileChange() {
      this.fileObj=URL.createObjectURL(this.file)
      const reader = new FileReader()
      reader.readAsDataURL(this.file)
      reader.onload = e => {
        if(e.total > 5242880){
          this.snackbar = true;
          this.snackbarText = "Please upload file below 5 MB";
          this.file = null;
          return;
        }

        this.item.permission_certificate = e.target.result
      }
    },
     onFileChangeExcision() {
      this.ExcisionSetInitalsObj=URL.createObjectURL(this.ExcisionSetInitals)
      const reader1 = new FileReader()
      reader1.readAsDataURL(this.ExcisionSetInitals)
      reader1.onload = e => {
      
        if(e.total > 5242880){
          this.snackbar = true;
          this.snackbarText = "Please upload file below 5 MB";
          this.ExcisionSetInitals = null;
          this.ExcisionSetInitalsObj = null
          return;
        }

        this.item.excision_set_initials = e.target.result
      }
    },
     onFileChangeLinen() {
      this.LinenSetInitialsObj=URL.createObjectURL(this.LinenSetInitials)
      const reader2 = new FileReader()
      reader2.readAsDataURL(this.LinenSetInitials)
      reader2.onload = e => {

        if(e.total > 5242880){
          this.snackbar = true;
          this.snackbarText = "Please upload file below 5 MB";
          this.LinenSetInitials = null;
          return;
        }

        this.item.linen_set_initials = e.target.result
      }
    },

    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if (keyCode < 48 || keyCode > 57 || $event.target._value.length > 9 ) {
          $event.preventDefault();
      }
    },

    onlyAge ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if (keyCode < 48 || keyCode > 57 || $event.target._value.length == 2 ) {
          $event.preventDefault();
      }
    },

    async editDonorinformation() {
      
      if(this.item.phone_no.length  < 10){
        return false,
        this.snackbarText = "Phone number should be 10 character.",
        this.snackbar = true
      }
      // else if(this.item.relation_with_donor == 'Others' && this.item.donorOtherRelationshipName == "" || this.item.donorOtherRelationshipName === null){
      //   return false,
      //   this.snackbarText = "Please fill relationship name.",
      //   this.snackbar = true
      // }
      else if(this.item.date_of_time_of_death == "" || this.item.date_of_time_of_death == "Invalid date" || this.item.date_of_time_of_death == null){
        return false,
        this.snackbarText = "Please fill date and time of death.",
        this.snackbar = true
      }else if(this.item.date_of_time_of_consent == "" || this.item.date_of_time_of_consent == "Invalid date" || this.item.date_of_time_of_consent == null){
        return false,
        this.snackbarText = "Please fill date and time of consent.",
        this.snackbar = true
      }else if(this.item.date_of_time_of_excision == "" || this.item.date_of_time_of_excision == "Invalid date" || this.item.date_of_time_of_excision == null){
        return false,
        this.snackbarText = "Please fill date and time of excision.",
        this.snackbar = true
      }else if(this.item.received_on == "" || this.item.received_on == "Invalid date" || this.item.received_on == null){
        return false,
        this.snackbarText = "Please fill received on.",
        this.snackbar = true
      }else if(this.item.excision_set_date_and_time_of_sterilization == "" || this.item.excision_set_date_and_time_of_sterilization == "Invalid date" || this.item.excision_set_date_and_time_of_sterilization == null){
        return false,
        this.snackbarText = "Please fill excision set date and time of sterilization.",
        this.snackbar = true
      }else if(this.item.excision_set_date_and_time_of_expiry == "" || this.item.excision_set_date_and_time_of_expiry == "Invalid date" || this.item.excision_set_date_and_time_of_expiry == null){
        return false,
        this.snackbarText = "Please fill excision set date and time of expiry.",
        this.snackbar = true
      }else if(this.item.linen_set_date_and_time_of_sterilization == "" || this.item.linen_set_date_and_time_of_sterilization == "Invalid date" || this.item.linen_set_date_and_time_of_sterilization == null){
        return false,
        this.snackbarText = "Please fill linen set date and time of sterilization.",
        this.snackbar = true
      }else if(this.item.linen_set_date_and_time_of_expiry == "" || this.item.linen_set_date_and_time_of_expiry == "Invalid date" || this.item.linen_set_date_and_time_of_expiry == null){
        return false,
        this.snackbarText = "Please fill linen set date and time of expiry.",
        this.snackbar = true
      }

      try {
        const data = {
          donor_name: this.item.donor_name,
          s_w_d_of: this.item.s_w_d_of,
          donor_parent_guardian_name: this.item.donor_parent_guardian_name,
          age: this.item.age,
          sex: this.item.sex,
          postal_address: this.item.postal_address,
          phone_no: this.item.phone_no,
          donor_relative_name: this.item.donor_relative_name,
          relation_with_donor: this.item.relation_with_donor,
          referral_name: this.item.referral_name,
          referral_contact_number: this.item.referral_contact_number,
          category_type_of_the_requesting_person: this.item.category_type_of_the_requesting_person,
          date_of_time_of_death: moment.utc(this.item.date_of_time_of_death).format('YYYY-MM-DD HH:mm'),
          date_of_time_of_consent: moment.utc(this.item.date_of_time_of_consent).format('YYYY-MM-DD HH:mm'),
          date_of_time_of_excision: moment.utc(this.item.date_of_time_of_excision).format('YYYY-MM-DD HH:mm'),
          cause_of_death: this.item.cause_of_death,
          temperature: this.item.temperature,
          consignment_information: this.item.consignment_information,
          received_on: moment.utc(this.item.received_on).format('YYYY-MM-DD HH:mm'),
          right_eye: this.item.right_eye,
          condition_of_right_eye_ball_cornea_at_time_of_receive: this.item.condition_of_right_eye_ball_cornea_at_time_of_receive,
          condition_of_right_eye_ball_cornea_at_time_of_inspection: this.item.condition_of_right_eye_ball_cornea_at_time_of_inspection,
          left_eye: this.item.left_eye,
          condition_of_left_eye_ball_cornea_at_time_of_receive: this.item.condition_of_left_eye_ball_cornea_at_time_of_receive,
          condition_of_left_eye_ball_cornea_at_time_of_inspection: this.item.condition_of_left_eye_ball_cornea_at_time_of_inspection,
          any_other_information: this.item.any_other_information,
          excision_set_date_and_time_of_sterilization: moment.utc(this.item.excision_set_date_and_time_of_sterilization).format('YYYY-MM-DD HH:mm'),
          excision_set_date_and_time_of_expiry: moment.utc(this.item.excision_set_date_and_time_of_expiry).format('YYYY-MM-DD HH:mm'),
          excision_set_initials: this.item.excision_set_initials,
          linen_set_date_and_time_of_sterilization: moment.utc(this.item.linen_set_date_and_time_of_sterilization).format('YYYY-MM-DD HH:mm'),
          linen_set_date_and_time_of_expiry: moment.utc(this.item.linen_set_date_and_time_of_expiry).format('YYYY-MM-DD HH:mm'),
          linen_set_initials: this.item.linen_set_initials,
          user_id: userId,
          donor_id: this.item.donor_id,
          permission_certificate: this.item.permission_certificate
          // donorOtherRelationshipName : this.item.donorOtherRelationshipName
        }
        const service = new donorService()
        const response = await service.updateDonorInformation(data)
        if(response.status == 200){
          this.snackbarText = response.message,
          this.snackbar = true
          setTimeout(() => {
            this.show = false
          }, 2000)
          this.$router.push({name:'Retrieval_Form', params: { donor_id: this.item.donor_id}});
        }else{
          this.snackbarText = response.message,
          this.snackbar = true
        }
      } catch (e) {
        console.log(e)
      }
    },
  },
}
</script>
